export default "__VITE_ASSET__CsohFMd7__"